module.exports = __webpack_public_path__ + "static/questions-color-icon-b1fc2b7f12cf888b98c462636cdf5ba1.png";